













































import Vue from "vue";
import Util from "./../../lib/util";

export default Vue.extend({
  name: "defined-role-selector",
  components: {},
  props: {
    parentRoleName: { type: String, default: null },
    childRoleName: { type: String, default: null },
  },
  data() {
    return {
      visible: false,
      commonList: [],
      myList: [],
    };
  },
  computed: {
    roleNameOptions(): any {
      return this.myList.concat(this.commonList);
    },
    saveRolesToListDisabled(): any {
      return (
        this.parentRoleName === null ||
        this.parentRoleName === "" ||
        this.childRoleName === null ||
        this.childRoleName === "" ||
        this.isRoleNameInList(`${this.parentRoleName} / ${this.childRoleName}`)
      );
    },
  },
  mounted() {
    let abp = Util.abp;
    this.commonList = abp.setting && abp.setting.values ? JSON.parse(abp.setting.values["App.CommonRoleList"]) : [];
    this.myList = abp.setting && abp.setting.values ? JSON.parse(abp.setting.values["App.MyRoleList"]) : [];

    this.$Notice.config({
      top: 120,
      duration: 3,
    });
  },
  methods: {
    handleClick(item) {
      this.visible = false;
      this.$emit("on-select", item);
    },
    handleRemove(item) {
      for (var i = 0; i < this.myList.length; i++) {
        if (this.myList[i] === item) {
          this.myList.splice(i, 1);
        }
      }

      this.changeMyRoleList();
    },
    handleSaveToList() {
      let id = 0;
      this.myList.forEach((item) => {
        if (item.value > id) {
          id = item.value;
        }
      });
      id = id + 1;
      this.myList.push({ value: id, label: `${this.parentRoleName} / ${this.childRoleName}`, disabled: false });

      this.changeMyRoleList();
    },
    changeMyRoleList() {
      this.$store.dispatch("review/changeMyRoleList", { model: JSON.stringify(this.myList) }).then((response) => {
        if (response.data && response.data.success === true) {
          Util.abp.setting.values["App.MyRoleList"] = JSON.stringify(this.myList);
        }

        this.$Notice.success({
          title: "Save",
          desc: "My role list updated! ",
        });
      });
    },
    isRoleNameInList(roleName) {
      return this.roleNameOptions.filter((option) => option.label === roleName).length >= 1;
    },
  },
});
